import * as React from 'react';
import Dropdown from '../common/Dropdown';
import { getEstimationMonths, getNextMonths, Month, monthByNumber } from './getEstimationMonths';

interface Props {
    monthSelected: (month: Month[]) => void;
    months: Month[];
}

class Months extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <>
                {this.props.months.map((value: Month, index: number) => {
                    if (index === 0) {
                        return (
                            <span>
                                <Dropdown
                                    key={value.month}
                                    options={this.getEstimationMonths().map((month: Month) => this.parseLabel(month))}
                                    placeholder="months"
                                    selectedOption={this.parseLabel(this.props.months[0])}
                                    onChange={this.monthSelected}
                                    class="admin-select"
                                    color="gray"
                                />
                            </span>
                        );
                    } else {
                        return <span key={index}>{this.parseLabel(value)}</span>;
                    }
                })}
            </>
        );
    }

    private parseLabel = (month: Month): string => monthByNumber[month.month] + '/' + month.year;

    private getEstimationMonths = (): Month[] => getEstimationMonths(this.getCurrentYear(), this.getCurrentMonth());

    private monthSelected = (id: string): void => {
        const selected: Month = this.getEstimationMonths().find((month: Month) => this.parseLabel(month) === id)!;
        this.props.monthSelected(getNextMonths(selected.year, selected.month));
    };

    private getCurrentYear = (): number => new Date().getFullYear();

    private getCurrentMonth = (): number => new Date().getMonth() + 1;
}

export default Months;



// WEBPACK FOOTER //
// ./src/view/admin/Months.tsx